import { activeSiteConfig } from "@config/site/site-config";
import { QueryKeys } from "@lib/enums/QueryKeys";
import { useApi } from "@lib/helpers/useApi";
import { getParcelShopsByCoordinates } from "@components/store-locator/utils/parcelShops";
import {
    canSearchParcelShops,
    fetchParcelShops,
    parcelShopsQueryKey,
} from "@components/store-locator/utils/parcelShopsQuery";
import { ShippingMethodTypes } from "../../types";
import type { StoreLocatorSearchValidation } from "@components/store-locator/controller";
import type { ParcelShopSearch } from "@components/store-locator/utils/parcelShopsQuery";
import type { StoreData } from "@features/stores/types";

type SearchProps = ParcelShopSearch & {
    shippingMethodKey?: ShippingMethodTypes;
    searchValidation: StoreLocatorSearchValidation;
};

export const useCheckoutParcelShopLocationResultsVB = ({
    clientLocation,
    shippingMethodKey,
}: Pick<SearchProps, "clientLocation" | "shippingMethodKey">): StoreData[] | undefined => {
    const { data } = useApi.useAsync(
        [QueryKeys.getParcelShops, clientLocation?.lat, clientLocation?.lng],
        () =>
            getParcelShopsByCoordinates({
                latitude: clientLocation?.lat,
                longitude: clientLocation?.lng,
            }),
        {
            enabled:
                activeSiteConfig.checkout?.parcelShops?.searchMethod === "latlng" &&
                !!clientLocation &&
                shippingMethodKey === ShippingMethodTypes.PARCEL_SHOP,
        }
    );

    return data;
};

export const useCheckoutParcelShopMapResultsVB = ({
    shippingMethodKey,
    searchValidation,
    ...search
}: SearchProps): StoreData[] | undefined => {
    const { data } = useApi.useAsync(parcelShopsQueryKey(search), () => fetchParcelShops(search), {
        enabled:
            shippingMethodKey === ShippingMethodTypes.PARCEL_SHOP &&
            !searchValidation.isRestricted &&
            !searchValidation.isValidating &&
            canSearchParcelShops(search),
    });

    return data;
};
